"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Response = void 0;
class Response {
    body;
    statusCode;
    headers;
    // cookies?: string[] | undefined;
    constructor(body, metadata) {
        this.body = body ?? {};
        this.headers = metadata?.headers ?? { 'Content-type': 'application/json' };
        this.statusCode = metadata?.statusCode ?? 200;
    }
}
exports.Response = Response;
